/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { FiMenu, FiChevronDown, FiChevronRight, FiShoppingBag, FiUser, FiX } from "react-icons/fi";
import { MdSearch } from "react-icons/md";
import Loader from "react-loader-spinner";
import Skeleton from "@material-ui/lab/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ThemeContext } from "styled-components";
import imgMenu from "../../assets/images/Menu.svg";
import searchSvg from "../../assets/images/search.svg";
import backSvg from "../../assets/images/back.svg";
import { Creators as SearchProductsActions } from "../../store/ducks/search";
import { Creators as SideMenuActions } from "../../store/ducks/sideMenu";
import { Creators as SuggestActions } from "../../store/ducks/suggest";
import HeaderPromotion from "../HeaderPromotion";
import { DELIVERY_CONTEXT_KEY } from "../../util/deliveryContextStorage";
import SideMenu from "../SideMenu";
import {
  Cart,
  Center,
  ContainerSearchMobile,
  Helper,
  LoaderContainer,
  Menu,
  MenuCategoriasSection,
  MobileSearchForm,
  Navigation,
  SearchForm,
  Signed,
  Suggest,
  User,
  MenuUl,
  SubMenuMobile,
  ContainerPromo,
  ImageProduct,
  MegaPanel,
  MegaSidebar,
  MegaContent,
  ChipList,
  Chip,
  MegaDestaques,
} from "./styles";
import { formatPrice, toSlug } from "../../util/format";
import TopbarIdentidadeVisual from "../TopbarIdentidadeVisual";
import useOutsideClick from "../../hooks/useOutsideClick";
import {
  handleProductImageError,
  hideImageOnError,
} from "../../util/imageFallback";
import { logoCabecalho, erroLogo } from "../../util/logoLoja";

// Sugestão da busca: o tipo do produto vem em produto_tipo ("tipo" é o da imagem). P-098.
const produtoDaSugestao = (suggest) => ({
  tarja: suggest.tarja,
  generico: suggest.generico,
  tipo: suggest.produto_tipo,
});

export default function Header() {
  const history = useHistory();
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const suggestRef = useRef(null);
  const searchInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [searchInputFocused, setSearchInputFocused] = useState(false);
  const { suggestions } = useSelector((state) => state.suggest);
  const { profile, loading: userLoading } = useSelector((state) => state.user);
  const { signed } = useSelector((state) => state.auth);
  const cart = useSelector((state) => state.cart.data);
  const headerRef = useRef(null);
  const { searchTerm: searchTermReducer } = useSelector(
    (state) => state.search
  );
  const { data } = useSelector((state) => state.store);
  const { data: menusModel } = useSelector((state) => state.menu);
  const { data: identidade } = useSelector((state) => state.identidadeVisual);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const megaMenuRef = useRef(null);
  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const [showSubMenuMobile, setShowSubMenuMobile] = useState(false);
  const [showItemMobile, setShowItemMobile] = useState(false);
  const [menuSelected, setMenuSelected] = useState(null);
  const [subMenuSelected, setSubMenuSelected] = useState(null);
  const [recentSearches, setRecentSearches] = useState([]);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const SEARCH_DEBOUNCE_DELAY = 400;

  const cores = identidade?.cores || {};
  const safeColor = (v, fb) =>
    typeof v === "string" && /^#([0-9a-f]{3}){1,2}$/i.test(v) ? v : fb;
  const headerFundo = safeColor(cores.header_fundo, "#fff");
  const headerTexto = safeColor(cores.header_texto, theme.colors.neutral900);
  const navbarFundo = safeColor(cores.navbar_fundo, "#fff");
  const navbarTexto = safeColor(cores.navbar_texto, theme.colors.neutral900);

  useOutsideClick(megaMenuRef, () => setShowMegaMenu(false));

  useEffect(() => {
    window.onscroll = () => {
      if (suggestions.length === 0) {
        // scrollFunction();
      }
    };
  }, [suggestions.length]);

  useEffect(() => {
    // Recarrega abas em segundo plano quando outra aba mexe no armazenamento local.
    // O contexto de entrega fica de fora: store/sagas/deliveryContext.js sincroniza o
    // estado por evento de storage, sem recarregar nada.
    function handleStorage(event) {
      if (event.key === DELIVERY_CONTEXT_KEY) return;
      if (document.visibilityState === "hidden") {
        window.location.reload(false);
      }
    }

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    const savedSearches =
      JSON.parse(localStorage.getItem("@ConexaoGAM:searchTermLocally")) || [];

    setRecentSearches(
      savedSearches
        .filter(
          (search) => search.term.toLowerCase() !== searchTerm.toLowerCase()
        )
        .sort((a, b) => new Date(b.date) - new Date(a.date)) // Ordena por data decrescente
    );
  }, [searchTerm, suggestions]);

  function handleSuggestion(event, url = null) {
    if (url) {
      dispatch(SuggestActions.clearSuggestions());
      history.push("/produtos/visualizar/" + url);
      setSearchTerm("");
    }
  }

  function handleSubmitMobile(event, suggest = null, searchTermLocally = null) {
    handleSubmit(event, suggest, searchTermLocally);

    // Chama a função de sincronização dos filtros
    setTimeout(() => {
      if (typeof window.forceSyncFilters === 'function') {
        window.forceSyncFilters();
      }
    }, 100);
  }

  function handleSubmit(event, suggest = null, searchTermLocally = null) {
    event.preventDefault();
    let term = suggest !== null ? suggest : searchTerm;

    if (searchTermLocally !== null) {
      term = searchTermLocally;
    }

    saveSearchTermLocally(term);

    if (searchTermReducer !== "") {
      dispatch(SuggestActions.clearSuggestions());

      // Encode URL para evitar problemas com caracteres especiais
      const encodedTerm = encodeURIComponent(term);
      const newPath = "/produtos/buscar/" + encodedTerm + "?page=1";
      const currentPath = history.location.pathname;

      // Se a URL é a mesma, força reload com key aleatória
      if (currentPath === newPath) {
        // Adiciona timestamp para forçar remount do componente
        history.replace(newPath + "&t=" + Date.now());
      } else {
        history.push(newPath);
      }

      setSearchTerm("");
      setSearchInputFocused(false);

      // Remove o foco do input
      if (searchInputRef.current) {
        searchInputRef.current.blur();
      }
    }
  }

  const setSearchTermState = useCallback((searchTerm) => {
    if (searchTerm === "") {
      dispatch(SuggestActions.clearSuggestions());
    } else if (searchTerm?.length > 2) {
      dispatch(SearchProductsActions.setSearchTerm(searchTerm));
    }
  }, [dispatch]);

  function doSearch(evt) {
    const nextSearchTerm = evt.target.value;
    setSearchTerm(nextSearchTerm);
  }

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearchTermState(searchTerm);
    }, SEARCH_DEBOUNCE_DELAY);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, setSearchTermState]);

  function saveSearchTermLocally(searchTerm) {
    if (searchTerm === undefined || searchTerm.length < 3) return;

    // Recupera as buscas existentes
    const existingSearches =
      JSON.parse(localStorage.getItem("@ConexaoGAM:searchTermLocally")) || [];

    // Verifica se o termo já existe
    const existingIndex = existingSearches.findIndex(
      (entry) => entry.term.toLowerCase() === searchTerm.toLowerCase()
    );

    if (existingIndex !== -1) {
      // Remove o termo duplicado para reordená-lo
      existingSearches.splice(existingIndex, 1);
    }

    // Cria um novo registro
    const searchEntry = {
      term: searchTerm,
      date: new Date().toISOString(),
    };

    // Adiciona o novo registro ao início do array
    existingSearches.push(searchEntry);

    // Remove os registros mais antigos, mantendo apenas os 6 mais recentes
    if (existingSearches.length > 3) {
      existingSearches.shift(); // Remove o primeiro (mais antigo)
    }

    // Salva o array atualizado no localStorage
    localStorage.setItem(
      "@ConexaoGAM:searchTermLocally",
      JSON.stringify(existingSearches)
    );
  }

  function getHighlightedText(suggest, higlight) {
    let parts = suggest.descricao.split(new RegExp(`(${higlight})`, "i"));
    return (
      <span className="span-desc">
        {" "}
        {parts.map((part, i) => (
          <span
            className="lowerCase"
            key={i}
            style={
              part.toLowerCase() === higlight.toLowerCase()
                ? { fontWeight: "500" }
                : {}
            }
          >
            {part}
          </span>
        ))}{" "}
        <p />
        <span>
          {suggest.percentual_desconto > 0 && (
            <span>
              <ContainerPromo>
                {parseFloat(suggest.percentual_desconto)
                  .toString()
                  .replace(".", ",")}
                % OFF
              </ContainerPromo>
              <p />
            </span>
          )}

          {suggest.preco_de !== suggest.preco_por && (
            <span>
              <span className="old-price">
                {" "}
                de: {formatPrice(suggest.preco_de)}
                <p />
              </span>
              <span className="price">
                por: {formatPrice(suggest.preco_por)}
              </span>
            </span>
          )}
          {suggest.preco_de === suggest.preco_por && (
            <span className="price">{formatPrice(suggest.preco_por)}</span>
          )}
        </span>
      </span>
    );
  }

  function searchMenu(menu, tipoMenu, event) {
    setSubMenuSelected(null);

    if (tipoMenu === "menu") {
      setMenuSelected(menu);
    }
    if (tipoMenu === "submenu") {
      setSubMenuSelected(menu);
    }
  }

  function clickMenu(menu) {
    setMenuSelected(null);
    setShowMegaMenu(false);

    if (showMenuMobile) closeAllMenusMobile();

    if (menu.tipo_link === "url") {
      const isAbsolute = /^https?:\/\//i.test(menu.url_link);
      if (menu.tipo_abertura_link === "_self") {
        if (isAbsolute) {
          window.location.href = menu.url_link;
        } else {
          history.push(menu.url_link);
        }
      } else {
        window.open(menu.url_link, menu.tipo_abertura_link);
      }
    } else if (menu.tipo_link === "categoria" && menu.categoria) {
      const slugDescricao = toSlug(menu.categoria.descricao);
      const path = `/produtos/categoria/${slugDescricao}/${menu.categoria.id}`;
      history.push(path);
    } else if (menu.tipo_link === "subcategoria" && menu.subcategoria) {
      const slugDescricao = toSlug(menu.subcategoria.descricao);
      const path = `/produtos/subcategoria/${slugDescricao}/${menu.subcategoria.id}`;
      history.push(path);
    } else if (menu.tipo_link === "segmento" && menu.segmento) {
      const slugNome = toSlug(menu.segmento.nome);
      const path = `/produtos/segmento/${slugNome}/${menu.segmento.id}`;
      history.push(path);
    }
  }

  function clickMenuMobile(menu) {
    if (menu.tipo === "menu") {
      setMenuSelected(menu);
      setShowSubMenuMobile(true);
    } else if (menu.tipo === "submenu") {
      setSubMenuSelected(menu);
      setShowItemMobile(true);
    } else {
      clickMenu(menu);
    }
  }

  function clickImage(menu) {
    setShowMegaMenu(false);
    if (
      menu.link_propaganda_imagem &&
      menu.tipo_abertura_link_propaganda_imagem
    ) {
      window.open(
        menu.link_propaganda_imagem,
        menu.tipo_abertura_link_propaganda_imagem
      );
    }
  }

  function closeAllMenusMobile() {
    setShowMenuMobile(false);
    setShowSubMenuMobile(false);
    setShowItemMobile(false);
  }

  function hasChildren(menu) {
    return menusModel.find((x) => x.pai_menu_id === menu.id) !== undefined;
  }

  function submenusOf(parentId) {
    return menusModel
      ? menusModel.filter(
          (m) => m.tipo === "submenu" && m.pai_menu_id === parentId
        )
      : [];
  }

  function itemsOf(parentId) {
    return menusModel
      ? menusModel.filter(
          (m) => m.tipo === "item" && m.pai_menu_id === parentId
        )
      : [];
  }

  function isPromo(menu) {
    return /promoç/i.test(menu?.descricao || "");
  }

  function toggleMegaMenu() {
    const next = !showMegaMenu;
    if (next && !menuSelected && menusModel) {
      const firstMenu = menusModel.find((m) => m.tipo === "menu");
      if (firstMenu) setMenuSelected(firstMenu);
    }
    setShowMegaMenu(next);
  }

  return (
    <>
      <HeaderPromotion visible={false} />
      <TopbarIdentidadeVisual />
      <Helper id="helper" visible={showSearch} />
      {/* Overlay que aparece quando o input está em foco */}
      {searchInputFocused && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
            pointerEvents: "auto",
          }}
          onClick={() => {
            setSearchInputFocused(false);
            setSearchTerm("");
            dispatch(SuggestActions.clearSuggestions());
          }}
        />
      )}
      <Menu ref={headerRef} visible={showSearch} hidden={false} searchFocused={searchInputFocused} fundo={headerFundo} texto={headerTexto}>
        <div className="menu-content">
          <Center>
            <div className="logo-menu">
              <div className="menu-btn-abrir">
                <span
                  onClick={() => {
                    setShowMenuMobile(true);
                  }}
                >
                  <img src={imgMenu} alt={"Abrir"} />
                </span>
              </div>
              <div className="logo">
                <button
                  onClick={() => {
                    dispatch(SideMenuActions.toggleSideMenu("openWithButton"));
                  }}
                  id="menu"
                >
                  <FiMenu size={30} />
                </button>
                <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                  {(!logoLoaded || !data?.empresa?.url) && (
                    <Skeleton variant="rect" animation="wave" width={134} height={40} style={{ borderRadius: 4 }} />
                  )}
                  {data?.empresa?.url && (
                    <img
                      src={logoCabecalho(identidade, data.empresa)}
                      title={data?.empresa?.nome}
                      alt={`${data?.empresa?.nome}`}
                      style={{ display: logoLoaded ? 'block' : 'none' }}
                      onLoad={() => setLogoLoaded(true)}
                      onError={(e) => { erroLogo(e); setLogoLoaded(true); }}
                    />
                  )}
                </Link>
              </div>
            </div>

            <SearchForm
              onSubmit={handleSubmit}
              openSuggest={suggestions.length > 0}
            >
              <div className="search-container">
                <img src={searchSvg} alt="Procurar" />
                <input
                  ref={searchInputRef}
                  type="search"
                  value={searchTerm}
                  placeholder="Busque por medicamento, produto ou marca..."
                  name="search"
                  onChange={(e) => doSearch(e)}
                  autoComplete="off"
                  inputMode="search"
                  onFocus={() => setSearchInputFocused(true)}
                  onBlur={() => setSearchInputFocused(false)}
                />
                <div className="div-custom-scroll">
                  {searchInputFocused && suggestions.length > 0 && (
                    <Suggest ref={suggestRef}>
                      {recentSearches.length > 0 && (
                        <span>
                          <span className="span-recent">Pesquisas recentes</span>
                          {recentSearches.map((search, index) => (
                            <li
                              className="li-recent"
                              key={index}
                              onMouseDown={(e) =>
                                handleSubmit(e, null, search.term)
                              }
                            >
                              {search.term}
                              <MdSearch />
                            </li>
                          ))}
                        </span>
                      )}
                      <br />
                      <span className="span-recent">Resultados da busca</span>
                      {suggestions &&
                        suggestions.map((suggest, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) =>
                              handleSuggestion(e, suggest.url)
                            }
                          >
                            <ImageProduct
                              src={suggest.caminho_imagem}
                              alt={suggest.descricao}
                              onError={handleProductImageError(
                                produtoDaSugestao(suggest)
                              )}
                            />
                            {getHighlightedText(suggest, searchTerm)}
                            <MdSearch />
                          </li>
                        ))}
                    </Suggest>
                  )}
                </div>
              </div>
            </SearchForm>

            <Navigation>
              <Cart id="carrinho">
                <Link to="/carrinho" title="Minha Cesta">
                  <span className="cart-icon">
                    <FiShoppingBag />
                  </span>
                  {cart?.itens?.length > 0 && (
                    <span className="cart-count">{cart.itens.length}</span>
                  )}
                </Link>
              </Cart>

              {!signed && !userLoading && (
                <User>
                  <Link to="/entrar" title="Login">
                    <span className="user-avatar">
                      <FiUser size={20} />
                    </span>
                  </Link>
                  <Link to="/entrar" title="Login">
                    <div className="user-text">
                      <b>Olá,</b>
                      Faça o login
                    </div>
                  </Link>
                </User>
              )}

              {signed && userLoading && (
                <Signed>
                  <LoaderContainer>
                    <Loader
                      type="Oval"
                      color={theme.colors.primary}
                      height={16}
                      width={16}
                    />
                  </LoaderContainer>
                </Signed>
              )}

              {signed && !userLoading && profile !== null && (
                <User>
                  <Link to="/painel" title="Meus dados">
                    <span className="user-avatar">
                      <FiUser size={20} />
                    </span>
                  </Link>
                  <Link to="/painel" title="Meus dados">
                    <div className="user-text">
                      <b>Olá,</b>
                      {profile && profile.nome.includes(" ")
                        ? profile.nome.substring(0, profile.nome.indexOf(" "))
                        : profile.nome}
                    </div>
                  </Link>
                </User>
              )}
              {/* <ToggleSearch onClick={() => toggleSearchBar()}>
            <MdSearch />
          </ToggleSearch> */}
            </Navigation>
          </Center>
        </div>
        <ContainerSearchMobile>
          <MobileSearchForm
            openSuggest={suggestions.length > 0}
            onSubmit={handleSubmitMobile}
            id="mobile-search-form"
          >
            <div className="search-container">
              <img src={searchSvg} alt="Procurar" />
              <input
                type="search"
                value={searchTerm}
                placeholder="O que você procura?"
                name="search-mobile"
                onChange={(e) => doSearch(e)}
                autoComplete="off"
                inputMode="search"
              />

              {suggestions.length > 0 && window.innerWidth <= 900 && (
                <Suggest ref={suggestRef}>
                  {recentSearches.length > 0 && (
                    <span>
                      <span className="span-recent">Pesquisas recentes</span>
                      {recentSearches.map((search, index) => (
                        <li
                          key={index}
                          onClick={(e) =>
                            handleSubmitMobile(e, null, search.term)
                          }
                        >
                          {search.term}
                          <MdSearch />
                        </li>
                      ))}
                    </span>
                  )}
                  <br />
                  <span className="span-recent">Resultados da busca</span>
                  {suggestions &&
                    suggestions.map((suggest, index) => (
                      <li
                        key={index}
                        onClick={(e) => handleSuggestion(e, suggest.url)}
                      >
                        <ImageProduct
                          src={suggest.caminho_imagem}
                          alt={suggest.descricao}
                          onError={handleProductImageError(
                            produtoDaSugestao(suggest)
                          )}
                        />
                        {getHighlightedText(suggest, searchTerm)}
                        <MdSearch />
                      </li>
                    ))}
                </Suggest>
              )}
            </div>
          </MobileSearchForm>
        </ContainerSearchMobile>
      </Menu>

      <MenuCategoriasSection navfundo={navbarFundo} navtexto={navbarTexto} ref={megaMenuRef}>
        <div
          className={`menu-categorias ${showMenuMobile ? "open-modal-mobile" : ""
            }`}
        >
            <div className="menu-topo">
              <FiMenu size={24} />
              <h2>Categorias</h2>
              <FiX
                className="menu-close-icon"
                size={22}
                onClick={closeAllMenusMobile}
              />
            </div>
            <MenuUl navtexto={navbarTexto}>
              <button
                type="button"
                className={`menu-trigger ${showMegaMenu ? "open" : ""}`}
                onClick={toggleMegaMenu}
              >
                <FiMenu size={18} />
                <span>MENU</span>
                <FiChevronDown
                  size={16}
                  className={`trigger-chevron ${showMegaMenu ? "open" : ""}`}
                />
              </button>

              {showMenuMobile && (
                <span className="mobile-section-label">TODAS AS CATEGORIAS</span>
              )}

              {menusModel &&
                menusModel
                  .filter((menu) => menu.tipo === "menu")
                  .map((menu) => (
                    <div
                      key={menu.id}
                      id={menu.id}
                      className={`dropdown ${isPromo(menu) ? "promo" : ""} ${
                        showMegaMenu && menuSelected?.id === menu.id
                          ? "active"
                          : ""
                      }`}
                      onMouseEnter={() => {
                        if (showMegaMenu) setShowMegaMenu(false);
                      }}
                    >
                      <a
                        onClick={() => {
                          if (showMenuMobile && hasChildren(menu))
                            clickMenuMobile(menu);
                          else clickMenu(menu);
                        }}
                      >
                        <span>{menu.descricao}</span>
                        {showMenuMobile && hasChildren(menu) && (
                          <FiChevronRight className="mobile-chevron" />
                        )}
                      </a>
                      {showMenuMobile && (
                        <div
                          className={`menu-mobile ${showSubMenuMobile ? "open-modal-mobile" : ""
                            }`}
                        >
                          <div className="menu-top-sub-item">
                            <FiMenu size={24} />
                            <h2>Categorias</h2>
                            <FiX
                              className="menu-close-icon"
                              size={22}
                              onClick={closeAllMenusMobile}
                            />
                          </div>
                          <SubMenuMobile>
                            <li className="li-back-mobile">
                              <a
                                className="link-back-mobile"
                                onClick={() => {
                                  setShowSubMenuMobile(false);
                                }}
                              >
                                <img
                                  className="img-back-mobile"
                                  src={backSvg}
                                  alt={"Voltar"}
                                />
                                {"Voltar"}
                              </a>
                            </li>
                            <li className="mobile-section-label">
                              {menuSelected?.descricao}
                            </li>
                            {menusModel &&
                              menusModel.find(
                                (m) =>
                                  m.tipo === "submenu" &&
                                  m.pai_menu_id === menuSelected?.id
                              ) && (
                                <li className="link-sub-item">
                                  <a
                                    className="link-see-all"
                                    onClick={() => clickMenu(menuSelected)}
                                  >
                                    {`Ver tudo de ${menuSelected?.descricao} →`}
                                  </a>
                                </li>
                              )}
                            {menusModel &&
                              menusModel
                                .filter(
                                  (m) =>
                                    m.tipo === "submenu" &&
                                    m.pai_menu_id === menuSelected?.id
                                )
                                .map((subMenu) => (
                                  <li
                                    key={subMenu.id}
                                    className="link-sub-item"
                                  >
                                    <a
                                      onClick={() => {
                                        if (hasChildren(subMenu))
                                          clickMenuMobile(subMenu);
                                        else clickMenu(subMenu);
                                      }}
                                    >
                                      {subMenu.descricao}
                                      {hasChildren(subMenu) && (
                                        <FiChevronRight className="mobile-chevron" />
                                      )}
                                    </a>
                                    {showMenuMobile && (
                                      <div
                                        className={`menu-mobile ${showItemMobile
                                          ? "open-modal-mobile"
                                          : ""
                                          }`}
                                      >
                                        <div className="menu-top-sub-item">
                                          <FiMenu size={24} />
                                          <h2>Categorias</h2>
                                          <FiX
                                            className="menu-close-icon"
                                            size={22}
                                            onClick={closeAllMenusMobile}
                                          />
                                        </div>
                                        <SubMenuMobile>
                                          <li className="li-back-mobile">
                                            <a
                                              className="link-back-mobile"
                                              onClick={() => {
                                                setShowItemMobile(false);
                                              }}
                                            >
                                              <img
                                                className="img-back-mobile"
                                                src={backSvg}
                                                alt={"Voltar"}
                                              />
                                              {menuSelected?.descricao}
                                            </a>
                                          </li>
                                          <li className="mobile-section-label">
                                            {subMenuSelected?.descricao}
                                          </li>
                                          {menusModel &&
                                            menusModel
                                              .filter(
                                                (m) =>
                                                  m.tipo === "item" &&
                                                  m.pai_menu_id ===
                                                  subMenuSelected?.id
                                              )
                                              .map((item) => (
                                                <li
                                                  key={item.id}
                                                  className="link-sub-item link-leaf-mobile"
                                                >
                                                  <a
                                                    onClick={() =>
                                                      clickMenu(item)
                                                    }
                                                  >
                                                    {item.descricao}
                                                  </a>
                                                </li>
                                              ))}
                                        </SubMenuMobile>
                                      </div>
                                    )}
                                  </li>
                                ))}
                          </SubMenuMobile>
                        </div>
                      )}
                    </div>
                  ))}
            </MenuUl>

            {showMegaMenu && window.innerWidth >= 900 && menuSelected && (
              <MegaPanel>
                <MegaSidebar navtexto={navbarTexto}>
                  {menusModel &&
                    menusModel
                      .filter((menu) => menu.tipo === "menu")
                      .map((menu) => (
                        <button
                          key={menu.id}
                          type="button"
                          className={
                            menuSelected?.id === menu.id ? "active" : ""
                          }
                          onMouseEnter={() => setMenuSelected(menu)}
                          onClick={() => setMenuSelected(menu)}
                        >
                          <span>{menu.descricao}</span>
                          <FiChevronRight size={16} />
                        </button>
                      ))}
                </MegaSidebar>

                <MegaContent>
                  <h3 className="mega-title">{menuSelected.descricao}</h3>
                  {submenusOf(menuSelected.id).length === 0 ? (
                    <a
                      className="see-all"
                      onClick={() => clickMenu(menuSelected)}
                    >
                      {`Ver tudo de ${menuSelected.descricao} →`}
                    </a>
                  ) : (
                    submenusOf(menuSelected.id).map((subMenu) => (
                      <div className="mega-section" key={subMenu.id}>
                        <h4
                          className="section-title"
                          onClick={() => clickMenu(subMenu)}
                        >
                          {subMenu.descricao}
                        </h4>
                        <ChipList>
                          {itemsOf(subMenu.id).map((item) => (
                            <Chip
                              key={item.id}
                              navtexto={navbarTexto}
                              onClick={() => clickMenu(item)}
                            >
                              {item.descricao}
                            </Chip>
                          ))}
                        </ChipList>
                      </div>
                    ))
                  )}
                </MegaContent>

                {menuSelected.url_imagem_propaganda && (
                  <MegaDestaques>
                    <h4>DESTAQUES</h4>
                    <a onClick={() => clickImage(menuSelected)}>
                      <img
                        src={menuSelected.url_imagem_propaganda}
                        alt={menuSelected.descricao}
                        onError={hideImageOnError}
                      />
                    </a>
                  </MegaDestaques>
                )}
              </MegaPanel>
            )}
          </div>
        </MenuCategoriasSection>

      <SideMenu />
    </>
  );
}
